import PropTypes from 'prop-types';
import styles from './FJTextToVideoScriptPaste.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import { useCallback } from 'react';
import { MAX_SCRIPT_LENGTH } from '../../../config/dataConfig/FJTextToVideoDataConfig';
import FJTextToVideoFooter from '../FJTextToVideoFooter/FJTextToVideoFooter';
const FJTextToVideoScriptPaste = props => {
    const { scriptPasteText, onChange, onPasteNext } = props;
    const _onChange = useCallback(
        e => {
            onChange(e.target.value);
        },
        [onChange],
    );

    return (
        <div className={styles.container}>
            <div className={styles.edit_content_box}>
                <textarea
                    className={styles.edit_content}
                    onChange={_onChange}
                    value={scriptPasteText}
                    placeholder={FJLocalStore._('paste-scripts-desc')}
                    maxLength={MAX_SCRIPT_LENGTH}
                />
                <div className={styles.count}>
                    {scriptPasteText.length} / {MAX_SCRIPT_LENGTH}
                </div>
            </div>
            <FJTextToVideoFooter>
                <FJButton
                    text={FJLocalStore._('next')}
                    className={styles.btn}
                    type={FJButtonType.GRADIENT}
                    onClick={onPasteNext}
                />
            </FJTextToVideoFooter>
        </div>
    );
};

FJTextToVideoScriptPaste.propTypes = {
    scriptPasteText: PropTypes.string,
    onChange: PropTypes.func,
    onPasteNext: PropTypes.func,
};

export default FJTextToVideoScriptPaste;
